import axios from 'axios';
import { API_BASE_URL } from '../config/api';

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.withCredentials = true;
axios.defaults.timeout = 60000; // 60s timeout for Render backend cold-start resilience

// Inject JWT token from localStorage into every request
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercept responses: handle 401 & retry transient network errors
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.dispatchEvent(new Event('auth-unauthorized'));
      return Promise.reject(error);
    }

    // Auto-retry once for GET requests on network failures or 503/504 (e.g. Render waking up)
    if (config && config.method === 'get' && !config._retry) {
      const isNetworkError = !error.response || [502, 503, 504].includes(error.response?.status);
      if (isNetworkError) {
        config._retry = true;
        await new Promise((resolve) => setTimeout(resolve, 2000));
        return axios(config);
      }
    }

    return Promise.reject(error);
  }
);

export default axios;
